import { vinSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const tripsBuilderTripsByVinResponseSchema = z.array(
  z.object({
    vin: vinSchema,
    end_date: z.coerce.date(),
    start_date: z.coerce.date(),
    distance: z.number(),
  }),
);

export type TripsBuilderTripsByVinResponse = z.infer<
  typeof tripsBuilderTripsByVinResponseSchema
>;
